import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_mof_document_line_attachment_RowClass,
} from '../../../dbschema';

export class MofDocumentLineAttachmentContainerModel extends BaseContainerModel {
  bl_aat_mof_document_line_attachment: bl_aat_mof_document_line_attachment_RowClass = new bl_aat_mof_document_line_attachment_RowClass();
}
